import { React } from "react";
import "../App.css";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { useUserAuth } from "../auth";
import { Link, useNavigate } from "react-router-dom";

const Register = () => {
	const { register } = useUserAuth();
	const navigate = useNavigate();
	const handleRegister = async (e) => {
		e.preventDefault();
		const name = e.target.username.value.trim();
		const email = e.target.email.value.trim();
		const password = e.target.password.value.trim();
		try {
			await toast
				.promise(register(name, email, password), {
					pending: "Registering...",
					success: "Registered successfully.",
				})
				.then(() => {
					navigate("/");
				});
		} catch (err) {
			toast(err.message);
		}
	};
	return (
		<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/Reset-password-pana.svg?alt=media')`, backgroundSize: "600px", backgroundPosition: "left" }}>
			<div id="registerForm" className="registerForm">
				<div className="title-div">
					<h3>Sign Up</h3>
				</div>
				<hr />
				<form onSubmit={handleRegister} className="form">
					<div className="form-groups">
						<div className="form-group">
							<input type="text" id="username" name="username" placeholder="Enter your name" pattern=".*\S+.*" title="This field is required" autoComplete="off" required />
							<label>Username</label>
						</div>
						<div className="form-group">
							<input type="email" id="email" name="email" placeholder="Enter registered Email ID" autoComplete="off" required />
							<label>Email</label>
						</div>
						<div className="form-group">
							<input type="password" id="password" name="password" placeholder="Enter registered password" autoComplete="off" required />
							<label>Password</label>
						</div>
					</div>
					<div className="buttons">
						<button type="submit" id="register" className="btn">
							Register
						</button>
					</div>
				</form>
				<div className="options">
					<p>Already have an account yet?</p>
					<Link className="optionlink" to="/login">
						Login
					</Link>
				</div>
			</div>
		</motion.section>
	);
};

export default Register;
